const getRolePrefix = (role) => {
  return role === 'therapist' ? '/t' : role === 'company' ? '/c' : '';
};

export default getRolePrefix;
